/**
 * Returns true when a compliance document may be outdated because the machine
 * classification was changed after the document was last generated or saved.
 *
 * Legacy null timestamps and missing documents never produce a stale result.
 */
export function isComplianceDocumentStaleAfterClassificationChange(
  classificationUpdatedAt: string | null | undefined,
  documentTimestamp: string | null | undefined
): boolean {
  if (classificationUpdatedAt == null || documentTimestamp == null) {
    return false
  }

  const classificationTime = Date.parse(classificationUpdatedAt)
  const documentTime = Date.parse(documentTimestamp)

  if (Number.isNaN(classificationTime) || Number.isNaN(documentTime)) {
    return false
  }

  return classificationTime > documentTime
}
